import { createSlice } from '@reduxjs/toolkit';

const cancelServiceSlice = createSlice({
  name: 'cancelService',
  initialState: {
    success: false,
    loading: false,
    cancelService: null,
    error: null,
  },
  reducers: {
    fetchCancelServiceRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCancelServiceSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.cancelService = action.payload;
    },
    fetchCancelServiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
      state.success = false
    },
    fetchCancelServiceReset(state) {
      state.loading = null
      state.success = null
      state.error = null;
    }
  },
});

export const { fetchCancelServiceRequest, fetchCancelServiceSuccess, fetchCancelServiceFailure ,fetchCancelServiceReset} = cancelServiceSlice.actions;
export default cancelServiceSlice.reducer;
